<template>
  <div class="row">
    <div
      class="col-12 col-md-6 col-lg-3 mb-4"
      v-for="plan in plans"
      :key="plan._id"
    >
      <div
        class="card h-100 plan-card"
        @click="selectPlan(plan._id)"
        :class="{ 'selected-plan': plan._id === selectedPlanId }"
      >
        <div class="card-body">
          <div class="d-flex justify-content-between align-items-center mb-4">
            <h5 class="card-title mb-0">{{ plan.price_title }}</h5>
            <span
              class="badge"
              :class="
                plan.price_type === 'free'
                  ? 'bg-success text-light'
                  : 'text-light bg-primary'
              "
            >
              {{
                plan.price_type === "free"
                  ? plan.price_type
                  : `Per ${capitalizeBilled(plan.billing_setting.billed)}`
              }}
            </span>
          </div>

          <ul class="list-unstyled">
            <li
              v-for="(feature, index) in plan.features"
              :key="index"
              class="d-flex align-items-center mb-2"
            >
              <span class="text-primary me-2">
                <inline-svg
                  src="/media/icons/duotune/general/gen037.svg"
                ></inline-svg>
              </span>
              <span>{{ feature.name }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import ApiService from "@/core/services/ApiService";
import { ref, defineEmits, onMounted, defineProps } from "vue";

const props = defineProps({
  modelValue: String,
});
const emit = defineEmits(["update:modelValue"]);
const plans = ref([]);

const selectedPlanId = ref(props.modelValue);

const selectPlan = (id) => {
  selectedPlanId.value = id;
  console.log(selectedPlanId.value);

  emit("update:modelValue", selectedPlanId.value);
};

const capitalizeBilled = (str) => {
  if (!str) return "";
  if (str === "daily") return "Day";
  return str.charAt(0).toUpperCase() + str.slice(1).slice(0, -2);
};

const getData = (size = 20, page = 1) => {
  ApiService.getWithoutSlug(
    "crmv2/main_feature/pricing-plans/all?" +
      "&" +
      "page=" +
      page +
      "&size=" +
      size
  )
    .then(({ data }) => (plans.value = data.content))
    .catch((error) => console.log(error));
};
onMounted(() => {
  getData();
});
</script>

<style scoped>
.plan-card {
  border: 2px solid #e9ecef;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
}

.plan-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 15px rgba(0, 0, 0, 0.07);
}

.selected-plan {
  background-color: #e7f1ff;
  border-color: #0d6efd;
  box-shadow: 0 8px 20px rgba(13, 110, 253, 0.2);
}

.selected-plan .bi-check-lg {
  color: #0d6efd !important;
}

.card-title {
  font-weight: 600;
}

.badge {
  font-size: 0.9rem;
  font-weight: 500;
}
</style>
